module.exports = __webpack_public_path__ + "static/media/discussions_illustration.dde99234.png";